import { IconButton, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const Title = styled.h1`
  ${tokens.text('subtitle2')};
  border-right: 1px solid ${tokens.color.ui_border};
  padding: 0 ${tokens.spacer.x1};
`;

const Header = styled.nav`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${tokens.color.ui_border};
  position: sticky;
  top: 0;
  background: ${tokens.color.ui_background};
  z-index: 10000;
`;

const Breadcrumbs = styled.div`
  display: flex;
  align-items: center;
  margin: ${tokens.spacer.x1} ${tokens.spacer.x2};
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.spacer.x1};
  margin-right: ${tokens.spacer.x3};
`;

export interface FullScreenHeaderProps {
  title: string;
  onClose: () => void;
  contextActions?: ReactNode;
}

export const FullScreenHeader = ({
  title,
  onClose,
  contextActions,
}: FullScreenHeaderProps): JSX.Element => {
  const { t } = useTranslation('common');
  return (
    <Header>
      <Breadcrumbs>
        <IconButton
          onClick={onClose}
          icon="close"
          kind="ghost"
          tooltipText={t('full-screen-view.actions.close')}
          description={t('full-screen-view.actions.close')}
          size="s"
        />
        <Title>{title}</Title>
      </Breadcrumbs>
      <Actions>{contextActions}</Actions>
    </Header>
  );
};
